<template>
  <div class="flex flex-col gap-2">
    <div v-for="(row, i) in internalRows" :key="i">
      <ui-form-field :error="errors?.[i]">
        <div class="flex gap-2">
          <ui-input
            :model-value="row"
            :error="!!errors?.[i]"
            type="text"
            small
            @update:model-value="updateRow($event, i)"
          />
          <button
            v-if="internalRows.length !== 1"
            type="button"
            class="bg-gray-10 hover:bg-gray-20 flex h-8 cursor-pointer items-center justify-center rounded-md px-2 py-1 duration-200 ease-out"
            @click="removeRow(i)"
          >
            <minus-icon class="h-4 w-4" />
          </button>
          <button
            v-if="i === internalRows.length - 1"
            type="button"
            class="bg-gray-10 hover:bg-gray-20 flex h-8 cursor-pointer items-center justify-center rounded-md px-2 py-1 duration-200 ease-out"
            @click="addRow"
          >
            <plus-icon class="h-4 w-4" />
          </button>
        </div>
      </ui-form-field>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UiInput, UiFormField } from '@klausapp/ui-kit'
import { PlusIcon, MinusIcon } from '@klausapp/ui-kit/icons'
import { ref, watch } from 'vue'

const props = defineProps<{
  modelValue?: string[]
  errors?: Record<number, string>
}>()

const emit = defineEmits<{
  (e: 'update:model-value', v: string[]): void
}>()

const internalRows = ref(props.modelValue?.length ? props.modelValue : [''])

watch(
  internalRows,
  () => {
    const filtered = internalRows.value.map((v) => v.trim()).filter((v) => !!v)
    emit('update:model-value', filtered.length ? filtered : undefined)
  },
  { deep: true },
)

const updateRow = (e: string, i: number) => {
  internalRows.value[i] = e
}

const removeRow = (i) => {
  internalRows.value = internalRows.value.filter((_, j) => j !== i)
}

const addRow = () => {
  internalRows.value = [...internalRows.value, '']
}
</script>
